/**
 * 白板固定配色 — 参考 Excalidraw 默认浅色主题
 * 不随站点四套主题切换，保证画布与手绘元素对比稳定、简洁大方
 */
export const BOARD_PALETTE = {
  bg: '#ffffff',
  grid: 'rgba(0, 0, 0, 0.06)',
  gridDot: 'rgba(0, 0, 0, 0.12)',
  stroke: '#1e1e1e',
  fill: 'transparent',
  shapeFill: '#f8f9fa',
  cardStroke: '#ced4da',
  cardFill: '#ffffff',
  cardSelected: '#6965db',
  text: '#1e1e1e',
  muted: '#868e96',
  guide: '#6965db',
};

export const CONNECTION_META = {
  blank: { color: '#000000', label: '' },
  related_to: { color: '#4dabf7', label: '相关' },
  depends_on: { color: '#e64980', label: '依赖' },
  includes: { color: '#40c057', label: '包含' },
  controls: { color: '#fab005', label: '控制' },
};

export function connectionMeta(type) {
  return CONNECTION_META[type] || CONNECTION_META.related_to;
}
